import { FeedBanner } from "./FeedBanner";

export default FeedBanner;
